<template>
  <el-main>
    <el-row>
      <h2>阅卷统计汇总</h2>
      {{ sel_xm }}
    </el-row>
    <el-row>
        <el-tabs v-model="activeName" type="border-card"    @tab-click="handleClick" >
              <el-tab-pane v-for="(item, index) in kemulist"  :name="index" :label="item" >{{activeName}}</el-tab-pane>      

              <vxe-table
                        ref="xTable"
                        height="400"
                        :seq-config="{startIndex: 0}"
                        :data="jindudata">     
                        <vxe-column field="kemu"  title="科目" sortable></vxe-column>                 
                        <vxe-column field="school"  title="学校" sortable></vxe-column>
                        <vxe-column field="yjer" title="账号"></vxe-column>
                        <vxe-column field="r_yj_er" title="姓名"></vxe-column>  
                        <vxe-column field="tizu" title="题组"></vxe-column>  
                        <vxe-column field="renwu" title="任务"></vxe-column>    
                        <vxe-column field="wancheng" title="已完成"></vxe-column>
                        <vxe-column field="ltime" title="最后评阅时间"></vxe-column>
                    
                </vxe-table>
 
        </el-tabs>
    </el-row>

  </el-main>
</template>
<script>
	import axios from 'axios'
	import qs from 'qs'
	import localStorage from 'localStorage'

	export default {
		data() {
		  return {
			kemulist: [],
      jindudata:[],
      activeName: '0',
			defaultProps: {
			   children: 'children',
						label: 'label',
						level: 'level'
					},
				sel_xm:'',
        sel_sb:'',
        sel_tizu:'',
        is_disable:true,
				is_jindu_disable:true,
				options:[],
				cascagerdefault: ["0", "0", ""]
				
		  };
		},
	
		mounted:function(){
			 
	
			  
		},

    activated() {

      this.getopt();//需要触发的函数

      },
          
	
		methods: {
		
      handleClick(tab, event) {

        this.getuploadsc()
        //获取对应科目上传信息
      },
		 
			getopt(){		
					        console.log('请求开始');
			 
                  this.sel_xm=localStorage.getItem('xm')
                  let kemul=localStorage.getItem('kemu')
                  this.kemulist=kemul.split(" ")
                 
                  let i=0;
                  for (i=0;i<this.kemulist.length-1;i++)
                  {
                    console.log(this.kemulist[i])
                  }									 
									
                  if (this.kemulist.length>0)
                  {
                    
                  }
					  			 		 
			},

      getuploadsc(){				 
			 
                  
                  this.sel_xm=localStorage.getItem('xm')
                  let selindex=Number(this.activeName);
                  let kemu=this.kemulist[selindex]
                  let svr_yuming=localStorage.getItem('svr_yuming')
                 
                  this.$http.post('/scoreman?op=jinduoneschoolonekemu',qs.stringify({"svr_yuming":svr_yuming,"xm_name":this.sel_xm,"kemu":kemu})).then(function(res){
                
                        
                          this.jindudata=res.data
                          console.log('请求结束') 
              
                  },function(){
                    console.log('请求失败处理');
                  });

									
					  	 				 
			},
	
 
	
		}
	  };
	</script>
	